export default class EstatedOwner {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.name = obj.name;
    this.second_name = obj.second_name;
    this.formatted_street_address = obj.formatted_street_address;
    this.unit_type = obj.unit_type;
    this.unit_number = obj.unit_number;
    this.city = obj.city;
    this.state = obj.state;
    this.zip_code = obj.zip_code;
    this.zip_plus_four_code = obj.zip_plus_four_code;
    this.owner_occupied = obj.owner_occupied;
  }

  get placeName() {
    return `${this.formatted_street_address}, ${this.city}, ${this.state} ${this.zip_code}`;
  }
}
